let API_URL;
const hostname = window && window.location && window.location.hostname;

if (hostname === "localhost" || hostname === "192.168.0.2") {
  API_URL = `http://${hostname}/smartotis.com/dashboard.smartotis.com/dashboard/`;
} else if (hostname === "dev.smartotis.com") {
  API_URL = `https://${hostname}/dashboard/`;
} else {
  API_URL = "https://dashboard.smartotis.com/dashboard/";
}
//API_URL = "https://dashboard.smartotis.com/dashboard/";

export default {
  appVersion: "1.0.2",
  defaultPath: "/dashboard",
  defaultPreLoginPath: "/login",
  basename: "", // only at build time to set, like /datta-able

  APIKEY: "CUR4-OHT3-ID6F-P1ZS-34C0-J4XE-7JMM-9KY0",
  API_HOST_URL: API_URL,
  WEB_URL: "http://localhost:3000/",
  isLoading: false,
};
